<form [formGroup]="mainInputFormGroup">
  <div class="main-input-form">
    <div>
      Желая финансова защита за сумата от
      <input class="amount-of-money-input" onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 || event.charCode == 44)" formControlName="amoutOfMoney" />

      @if (
        (mainInputFormGroup.controls['amoutOfMoney'].dirty ||
        mainInputFormGroup.controls['amoutOfMoney'].touched) &&
        (mainInputFormGroup.controls['amoutOfMoney'].errors?.pattern ||
        mainInputFormGroup.controls['amoutOfMoney'].errors?.required)) {
        <div class="error-text-container">
          @if (
            mainInputFormGroup.controls['amoutOfMoney'].errors?.pattern ||
            mainInputFormGroup.controls['amoutOfMoney'].errors?.required) {
            <div class="arrow-up"></div>
          }
          @if (mainInputFormGroup.controls['amoutOfMoney'].errors?.required) {
            <div class="error-message">
              <small>Задължително поле</small>
            </div>
          }
        </div>
      }
      @if (doubleVisualization) {
        <span> <span [ngClass]="{'blue-color':isCurrencyBGN, 'grey-color': !isCurrencyBGN}" class="bgn-currency-span" (click)="changeCurrencyToBGN()">ЛВ </span> / </span>
      }

      <span [ngClass]="{'blue-color':isCurrencyEUR, 'grey-color': !isCurrencyEUR}" class="eur-currency-span" (click)="changeCurrencyToEUR()">ЕВРО</span>
      за период от
      <input class="years-input" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" formControlName="yearsOfDuration" min="10" max="30" maxlength="2" /> години.

      @if (
        (mainInputFormGroup.controls['yearsOfDuration'].touched ||
        mainInputFormGroup.controls['yearsOfDuration'].dirty) &&
        (mainInputFormGroup.controls['yearsOfDuration'].errors?.pattern ||
        mainInputFormGroup.controls['yearsOfDuration'].errors?.required ||
        mainInputFormGroup.controls['yearsOfDuration'].errors?.min ||
        mainInputFormGroup.controls['yearsOfDuration'].errors?.max)) {
        <div class="error-text-container">
          @if (
            mainInputFormGroup.controls['yearsOfDuration'].errors?.pattern ||
            mainInputFormGroup.controls['yearsOfDuration'].errors?.required ||
            mainInputFormGroup.controls['yearsOfDuration'].errors?.min ||
            mainInputFormGroup.controls['yearsOfDuration'].errors?.max) {
            <div class="arrow-up"></div>
          }
          @if (mainInputFormGroup.controls['yearsOfDuration'].errors?.pattern) {
            <div class="error-message">
              <small class="w-100">Позволени символи: цифри от 0 до 9.</small>
            </div>
          }
          @if (mainInputFormGroup.controls['yearsOfDuration'].errors?.required) {
            <div class="error-message">
              <small>Задължително поле</small>
            </div>
          }
          @if (mainInputFormGroup.controls['yearsOfDuration'].errors?.min) {
            <div class="error-message">
              <small>Минимална стойност: 10</small>
            </div>
          }
          @if (mainInputFormGroup.controls['yearsOfDuration'].errors?.max) {
            <div class="error-message">
              <small>Максимална стойност: 30</small>
            </div>
          }
        </div>
      }

      Искам да плащам с
      <span [ngClass]="{'blue-color':isPaymentPerMonthSelected, 'grey-color': !isPaymentPerMonthSelected}" class="payment-per-month-span"
      (click)="changePaymentPerMonth()">месечни</span>
      /
      <span [ngClass]="{'blue-color':isPaymentPerYearSelected, 'grey-color': !isPaymentPerYearSelected}" class="payment-per-year-span"
      (click)="changePaymentPerYear()">годишни</span> вноски.
      <div>

        Роден/а съм на:
        <input class="born-date-input" formControlName="dateOfBorn" minlength="1" maxlength="10" onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" (focus)="inputClick=true" (focusout)="inputClick=false" placeholder="DD.MM.YYYY"/>

        @if (inputClick && mainInputFormGroup.invalid || !isDateCorrect) {
          <div class="info-message">
            <small>Възрастта трябва да бъде между 14 г. и 60 г. и не повече от 70 г. в края на програмата</small>
          </div>
        }

        @if (
          (mainInputFormGroup.controls['dateOfBorn'].dirty ||
          mainInputFormGroup.controls['dateOfBorn'].touched) &&
          (mainInputFormGroup.controls['dateOfBorn'].errors?.pattern ||
          mainInputFormGroup.controls['dateOfBorn'].errors?.required)) {
          <div class="error-text-container">
            @if (
              mainInputFormGroup.controls['dateOfBorn'].errors?.pattern ||
              mainInputFormGroup.controls['dateOfBorn'].errors?.required) {
              <div class="arrow-up"></div>
            }
            @if (mainInputFormGroup.controls['dateOfBorn'].errors?.pattern) {
              <div class="error-message">
                <small class="w-100">Позволени символи: цифри и точки. Валиден формат дата: DD.MM.YYYY</small>
              </div>
            }
            @if (mainInputFormGroup.controls['dateOfBorn'].errors?.required) {
              <div class="error-message">
                <small>Задължително поле</small>
              </div>
            }
            <!-- <div *ngIf="mainInputFormGroup.controls['dateOfBorn'].errors?.maxlength">
            <small>Максимална дължина: 10 символа</small>
          </div> -->
        </div>
      }

    </div>
  </div>
  <div class="protect-custom-package-extended-part-button-error-text">
    @if (isThereEmptyField) {
      <small>Всички полета са задължителни! Моля попълнете празните полета в текста по-горе!</small>
    }
    @if (!isBornDateCharactersCorrect) {
      <small>Годината Ви на раждане трябва да съдържа само цифри и точки!</small>
    }
    @if (!isBornDateMonthAndDayCorrect) {
      <small>Годината Ви на раждане съдържа невалиден месец или ден!</small>
    }
    @if (!isBornDateLengthCorrect) {
      <small>Годината Ви на раждане трябва да съдържа 10 символа!</small>
    }
    @if (!isSumEnough && isPaymentPerMonthSelected && isCurrencyBGN) {
      <small>Минималната вноска трябва да бъде 25 лв.</small>
    }
    @if (!isSumEnough && isPaymentPerMonthSelected && isCurrencyEUR) {
      <small>Минималната вноска трябва да бъде 12,50 евро.</small>
    }
    @if (!isSumEnough && isPaymentPerYearSelected && isCurrencyBGN) {
      <small>Минималната вноска трябва да бъде 300 лв.</small>
    }
    @if (!isSumEnough && isPaymentPerYearSelected && isCurrencyEUR) {
      <small>Минималната вноска трябва да бъде 150 евро.</small>
    }
    <br>
      @if (!isSumEnough) {
        <small>
          При сумата от {{amoutOfMoney}} {{bgCurrency | lowercase}}, вноската Ви е: {{manPrem}} {{bgCurrency | lowercase}} и е недостатъчна за желаната от Вас финансова защита.
          <br> Моля, увеличете сумата и/или периода.</small>
        }
        <!-- <small *ngIf="!isBornDateCorrect">Вашата възраст трябва да бъде между 14 и 60г. и не повече от 70г. в края на програмата.</small> -->
        @if (!isYearsOfDurationCorrect) {
          <small>Периодът трябва да бъде между 10 и 30 години.</small>
        }
      </div>

    </div>
  </form>
